export function generateCourseStructure({ toc, isGated, progressMap = {}, initialPageId }) {
  const sections = [];
  const pages = [];
  let nextAvailablePageId = undefined;
  let currentSectionId = undefined;
  let lastUnlockedPageId = undefined;

  let canUnlock = true;

  (toc || []).forEach((section) => {
    const rawPages = [
      ...(Array.isArray(section.pages)
        ? section.pages
        : Object.values(section.pages))
    ].sort((a, b) => (a._localOrder ?? 0) - (b._localOrder ?? 0));

    const sectionPages = [];
    const pageIds = [];
    let sectionLocked = false;

    rawPages.forEach((page) => {
      const progress = progressMap?.[page.id] ?? page.progress ?? 0;

      const isLocked = isGated && !canUnlock && page.id !== 'diploma';

      if (!isLocked && !nextAvailablePageId) {
        nextAvailablePageId = page.id;
      }

      if (!isLocked) {
        lastUnlockedPageId = page.id;
      }

      if (page.id === initialPageId && !isLocked) {
        currentSectionId = section.id;
      }

      sectionPages.push({
        ...page,
        sectionId: section.id,
        progress,
        isLocked,
      });

      pageIds.push(page.id);

      if (!isLocked) {
        canUnlock = Number(progress) === 1;
      }
    });

    sectionLocked = sectionPages[0]?.isLocked || false;

    sections.push({
      ...section,
      pages: pageIds,
      isLocked: sectionLocked,
    });

    pages.push(...sectionPages);
  });

  return {
    sections,
    pages,
    nextAvailablePageId,
    currentSectionId,
    lastUnlockedPageId,
  };
}


export function isPageLockedByProgress({ pageId, pages, isGated }) {
  if (!isGated) return false;

  let unlocked = true;

  for (const page of pages) {
    const progress = page.progress ?? 0;

    if (page.id === pageId) {
      return !unlocked;
    }

    unlocked = Number(progress) === 1;
  }

  return true;
}
